import Checkbox from "../../../shared/components/form/Checkbox";

function GoodBehaviourLabel() {
    return (
        <div>
            <p>J’accepte les conditions de transports de La Malle Postale :</p>
            <div className="prose prose-sm">
                <ul className={"max-w-[650px] list-disc pl-8 font-normal"}>
                    <li>Le poids de mon bagage <span className="font-bold">ne doit pas dépasser 13 kg</span></li>
                    <li>
                        Mon bagage doit être <span className="font-bold">disponible à partir de 8h</span> dans les hébergement réservés
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default function GoodBehaviourAgreement({ className, onChange }) {
    return (
        <div className={className}>
            <Checkbox onChange={onChange} name="goodBehaviourAgreement" label={<GoodBehaviourLabel />} />
        </div>
    );
}
